import { cx } from '@/lib/utils';

type MasonryGridProps = {
  children?: React.ReactNode;
  className?: string;
};

const MasonryGrid = ({ children, className }: MasonryGridProps) => {
  return (
    <div className={cx('mx-auto w-full columns-2 gap-[22px] space-y-[22px] md:columns-3', className)}>{children}</div>
  );
};

export default MasonryGrid;
